import React from 'react';
import { Col, Row } from 'react-grid-system';
import PropTypes from 'prop-types';
import Section from '../Section';
import Accordion from '../Accordion';

function AccordionSection(props) {
  return (
    <Section>
      <Col xs={12}>
        {props.items && (
          <Accordion>
            {props.items.map((item) => {
              let content = null;

              if (item.content.length > 1) {
                content = (
                  <Row>
                    {item.content.map(contentBlock => (
                      <Col md={12 / item.content.length} key={contentBlock.id}>
                        <div dangerouslySetInnerHTML={{ __html: contentBlock.content.childMarkdownRemark.html }} />
                      </Col>
                    ))}
                  </Row>
                );
              } else {
                content = (
                  <div dangerouslySetInnerHTML={{ __html: item.content[0].content.childMarkdownRemark.html }} />
                );
              }

              return (
                <Accordion.Item key={item.id} title={item.title}>
                  {content}
                </Accordion.Item>
              );
            })}
          </Accordion>
        )}
      </Col>
    </Section>
  );
}

export default AccordionSection;

AccordionSection.propTypes = {
  items: PropTypes.array,
};
